export const isClubSatellite = (clubType: string) =>
  clubType === 'Satellite_Club';
